import React from 'react';
import { useClinic } from '@/contexts/ClinicContext';
import PatientChart from '@/pages/PatientChart';
import PatientDetail from '@/pages/PatientDetail';

/**
 * Smart patient view router — renders the three-panel PatientChart for
 * practitioners (including dual-role clinic admin + provider users),
 * falls back to PatientDetail for admin-only users.
 */
const PatientViewRouter: React.FC = () => {
  const { isPractitioner } = useClinic();
  return isPractitioner ? <PatientChart /> : <PatientDetail />;
};

export default PatientViewRouter;
